import { defineKey as T } from 'ha/i18n';

export const STATE_NAME = 'inbox';
export const ACTIONS_PREFIX = 'Inbox';
export const PAGE_SIZE = 10;
export const INBOX_PAGER_WIDTH_XS = 5;
export const INBOX_PAGER_WIDTH = 9;
export const LISTINGS_THUMB = '81x81';

export const RESET_STATE = `${ACTIONS_PREFIX}/RESET_STATE`;

export enum Kinds {
  INBOX = 'inbox',
  PENDING = 'pending',
  FAVORITE = 'favorited',
  ARCHIVED = 'archived',
  PAID = 'paid',
  EXPIRED = 'expired',
  ALL = 'all',
  UNREAD = 'unread',
}

export const KindFilterGroups = {
  main: [
    {
      type: Kinds.INBOX,
      title: T('Inbox'),
      icon: 'inbox',
      category: 'inbox',
      displayUnreadBadge: true,
      unreadBadgeKind: 'mint',
    },
    {
      type: Kinds.FAVORITE,
      title: T('Shortlist'),
      icon: 'thumbs-up',
      category: 'favorited',
      displayUnreadBadge: false,
      unreadBadgeKind: 'mint',
    },
    {
      type: Kinds.ARCHIVED,
      title: T('Archive'),
      icon: 'thumbs-down',
      category: 'archived',
      displayUnreadBadge: false,
      unreadBadgeKind: 'mint',
    },
  ],
  secondary: [
    {
      type: Kinds.PENDING,
      title: T('Pending'),
      icon: 'hourglass-half',
      category: 'pending',
      displayUnreadBadge: true,
      unreadBadgeKind: 'brand',
    },
    {
      type: Kinds.PAID,
      title: T('Booking'),
      icon: 'calendar-check-o',
      category: 'paid',
      displayUnreadBadge: true,
      unreadBadgeKind: 'brand',
    },
    {
      type: Kinds.EXPIRED,
      title: T('Expired'),
      icon: 'clock-o',
      category: 'expired',
      displayUnreadBadge: true,
      unreadBadgeKind: 'brand',
    },
  ],
  rest: [
    {
      type: Kinds.ALL,
      title: T('All'),
      icon: 'list',
      category: 'all',
      displayUnreadBadge: false,
      unreadBadgeKind: 'purple',
    },
    {
      type: Kinds.UNREAD,
      title: T('Unread'),
      icon: 'envelope',
      category: 'allUnread',
      displayUnreadBadge: false,
      unreadBadgeKind: 'purple',
    },
  ],
};
